<script setup lang="ts">
import { BoxComponent } from '..'

const props = withDefaults(
  defineProps<{
    p?: string | number
    pt?: string | number
    pr?: string | number
    pb?: string | number
    pl?: string | number
  }>(),
  {
    p: undefined,
    pt: 32,
    pr: 32,
    pb: 96,
    pl: 32,
  },
)
</script>

<template>
  <BoxComponent class="page-wrapper" :p="props.p" :pt="props.pt" :pr="props.pr" :pb="props.pb" :pl="props.pl">
    <slot />
  </BoxComponent>
</template>

<style scoped lang="scss">
.page-wrapper {
  overflow: auto;
  position: relative;
  min-height: calc(100vh - 72px);
  max-width: 1264px;
  margin: 0 auto;
}
</style>
